import styled from 'styled-components';

export const PanelHeaderContentStyled = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  .top {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    padding-bottom: px(11);
    margin-top: px(-4);
  }
  .bottom {
    display: flex;
    flex-direction: row;
    margin-top: 0;
    padding-bottom: px(6);
    margin-bottom: px(6);

    .gender-slot-container {
      @media (--m-d-viewport) {
        margin-bottom: 0;
        padding-bottom: 0;
      }
    }
  }
`;
